module.exports = __webpack_public_path__ + "static/media/Miysis_images_HD.86c964aa.zip";